import styled from 'styled-components';
import { StyledButton, StyledLink } from '@/components/general';

import * as text from '@/components/general/TextStyles';

interface IBox {
  $hasCaption?: boolean;
}

export const Box = styled.div<IBox>`
  width: 100%;
  max-width: 1105px;
  margin: 130px auto 0;
  background-color: ${(props) => props.theme.colors.blue};
  border-radius: 31px;
  color: ${(props) => props.theme.colors.white};
  padding: ${(props) =>
    props.$hasCaption ? '60px 30px 30px' : '60px 30px 70px'};
  min-height: 350px;
  position: relative;
  display: flex;
  align-items: center;
  z-index: 0;
  overflow: hidden;

  @media (max-width: ${(props) => props.theme.breakpoints.lg}px) {
    padding: ${(props) =>
      props.$hasCaption ? '50px 25px 20px' : '50px 25px 60px'};
    margin-top: 75px;
  }
  @media (max-width: ${(props) => props.theme.breakpoints.sm}px) {
    min-height: 0px;
    margin-top: 45px;
  }
`;

export const Content = styled.div`
  position: relative;
  z-index: 2;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const Title = styled.h2`
  ${text.FS42_LG}
  margin-bottom: 15px;
  text-align: center;
  font-weight: ${(props) => props.theme.weights.bold};

  @media (max-width: ${(props) => props.theme.breakpoints.md}px) {
    margin-bottom: 20px;
  }
`;

export const Description = styled.p`
  ${text.FS17}
  font-weight: ${(props) => props.theme.weights.regular};
  text-align: center;
  color: #fdffff;
  max-width: 524px;
  margin-bottom: 40px;

  @media (max-width: ${(props) => props.theme.breakpoints.lg}px) {
    padding: 0;
    font-size: 17px;
  }

  @media (max-width: ${(props) => props.theme.breakpoints.md}px) {
    margin-bottom: 35px;
    max-width: 80%;
  }
  @media (max-width: ${(props) => props.theme.breakpoints.sm}px) {
    max-width: none;
  }
`;

export const ButtonBox = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  column-gap: 20px;
  flex-wrap: wrap;
  row-gap: 10px;

  @media (max-width: ${(props) => props.theme.breakpoints.sm}px) {
    width: 100%;
  }

  & a,
  button {
    border-radius: 16px;
    width: 180px;
    height: 56px;
    font-size: 17px;
    text-align: center;

    @media (max-width: ${(props) => props.theme.breakpoints.md}px) {
      font-size: 15px;
      height: 50px;
      width: 167px;
      max-width: 170px;
    }
    @media (max-width: 454px) {
      width: 100%;
      max-width: none;
    }

    &:first-child {
      background-color: ${(props) => props.theme.colors.black};
    }
  }
`;

export const Button = styled(StyledButton)`
  width: 200px;
  height: 50px;

  @media (max-width: ${(props) => props.theme.breakpoints.md}px) {
    width: 220px;
  }
  @media (max-width: ${(props) => props.theme.breakpoints.xs}px) {
    width: 100%;
  }
`;

export const ButtonLink = styled(StyledLink)``;

export const CaptionText = styled.span`
  ${text.FS14}
  margin-top: 50px;
  color: #d5eeff;
  text-align: center;

  @media (max-width: ${(props) => props.theme.breakpoints.sm}px) {
    margin-top: 25px;
  }

  & a {
    &::before {
      bottom: -1.5px;
    }
  }
`;

export const BlueBlurEllipse = styled.div`
  background-color: ${(props) => props.theme.colors.white};
  width: 100%;
  aspect-ratio: 1/0.33;
  position: absolute;
  pointer-events: none;
  left: calc(80 / 1330 * 100%);
  top: 50%;
  transform: translateY(-30%) rotate(-23.71deg);
  border-radius: 50%;
  filter: blur(150px);
  will-change: transform;
  opacity: 0.4;
  z-index: 1;

  @media (max-width: ${(props) => props.theme.breakpoints.lg}px) {
    left: calc(50 / 1330 * 100%);
    transform: translateY(-40%) rotate(-23.71deg);
    filter: blur(120px);
    width: 125%;
  }
  @media (max-width: ${(props) => props.theme.breakpoints.md}px) {
    filter: blur(100px);
    transform: translateY(-50%) rotate(-23.71deg);
  }
  @media (max-width: ${(props) => props.theme.breakpoints.sm}px) {
    left: calc(-80 / 568 * 100%);
    filter: blur(85px);
    width: 150%;
  }
`;
